var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.435-240q-22.997 0-42.062-10.731-19.065-10.73-32.065-29.5L160-480l141.308-198.231q13-18.769 32.153-30.269 19.154-11.5 41.924-11.5h369.231q22.442 0 38.913 16.471Q800-687.058 800-664.616v369.232q0 22.442-16.471 38.913Q767.058-240 744.616-240H375.435Zm393.796-30.769v-418.462V-270.769Zm-398.585 0h373.97q9.23 0 16.923-7.692 7.692-7.693 7.692-16.923v-369.232q0-9.23-7.692-16.923-7.693-7.692-16.923-7.692H370.538q-11.538 0-21.923 5.769-10.384 5.77-16.538 14.231L198.077-480l134.108 189.231q6.154 8.461 16.538 14.231 10.385 5.769 21.923 5.769Zm68.123-79.846L546.154-458l107.385 107.385 23-22.231L568.154-480l107.154-107.154-22.231-22.231L546.154-502 438.769-609.385l-22.231 22.231L524.154-480 416.538-372.846l22.231 22.231Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.9932ad4bb2c4d1167ea69db158b37e7f.svg";
export { ForwardRef as ReactComponent };